/**
 * Created by leo108 on 2019/11/16.
 */
import axios from 'axios'
import { bus } from '../common/setup-app/event-bus.js'

bus.$on('refresh-state', () => {
  axios.get(Spark.router('api.frontend_state'))
    .then(resp => {
      Spark.state.user = resp.data.user
      Spark.state.currentTeam = resp.data.currentTeam

      bus.$emit('state-refreshed')
    })
})
